var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueUrgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1047"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.88281,
    y: 5.87793,
    width: 7.83555,
    height: 7.83673,
    rx: 1.95918,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.88281,
    y: 5.87793,
    width: 7.83555,
    height: 7.83673,
    rx: 1.95918,
    fill: "#979797",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9249 2.93896C3.38389 2.93896 2.94531 3.37754 2.94531 3.91856V9.79611C2.94531 10.3371 3.38389 10.7757 3.92491 10.7757C4.46611 10.7757 4.90484 10.337 4.90484 9.79577V5.87782C4.90484 5.33681 5.34342 4.89823 5.88443 4.89823H9.80119C10.3422 4.89823 10.7809 4.45961 10.7809 3.91856C10.7809 3.37754 10.3423 2.93896 9.80127 2.93896H3.9249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9249 2.93896C3.38389 2.93896 2.94531 3.37754 2.94531 3.91856V9.79611C2.94531 10.3371 3.38389 10.7757 3.92491 10.7757C4.46611 10.7757 4.90484 10.337 4.90484 9.79577V5.87782C4.90484 5.33681 5.34342 4.89823 5.88443 4.89823H9.80119C10.3422 4.89823 10.7809 4.45961 10.7809 3.91856C10.7809 3.37754 10.3423 2.93896 9.80127 2.93896H3.9249Z",
    fill: "#979797",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.983498 0C0.442484 0 0.00390625 0.438579 0.00390625 0.979592V6.85714C0.00390625 7.39816 0.442485 7.83673 0.983499 7.83673C1.5247 7.83673 1.96343 7.398 1.96343 6.8568V2.93886C1.96343 2.39784 2.40201 1.95926 2.94302 1.95926H6.85978C7.40084 1.95926 7.83945 1.52065 7.83945 0.979592C7.83945 0.438578 7.40087 0 6.85986 0H0.983498Z",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3706 9.71394C15.3706 12.8384 12.8382 15.3711 9.71445 15.3711C6.59071 15.3711 4.05826 12.8384 4.05826 9.71394C4.05826 6.58949 6.59071 4.05679 9.71445 4.05679C12.8382 4.05679 15.3706 6.58949 15.3706 9.71394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3706 9.71394C15.3706 12.8384 12.8382 15.3711 9.71445 15.3711C6.59071 15.3711 4.05826 12.8384 4.05826 9.71394C4.05826 6.58949 6.59071 4.05679 9.71445 4.05679C12.8382 4.05679 15.3706 6.58949 15.3706 9.71394Z",
    fill: "#D01400",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3706 9.71394C15.3706 12.8384 12.8382 15.3711 9.71445 15.3711C6.59071 15.3711 4.05826 12.8384 4.05826 9.71394C4.05826 6.58949 6.59071 4.05679 9.71445 4.05679C12.8382 4.05679 15.3706 6.58949 15.3706 9.71394Z",
    stroke: "white",
    strokeWidth: 1.25714
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.7,
    d: "M11.8155 9.29695H10.7429V6.79809C10.7429 6.21754 10.4274 6.09765 10.0426 6.53306L9.76497 6.84857L7.4179 9.51781C7.09613 9.88381 7.22862 10.1804 7.71444 10.1804H8.78702V12.6793C8.78702 13.2598 9.10249 13.3797 9.48736 12.9443L9.76497 12.6288L12.112 9.95953C12.4338 9.59354 12.3013 9.29695 11.8155 9.29695Z",
    fill: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueUrgent);
export default __webpack_public_path__ + "static/media/queue_urgent.59fd42d7384134eec9f095c31c9bee1f.svg";
export { ForwardRef as ReactComponent };